module.exports = __webpack_public_path__ + "img/img84.8d23c9ce.png";